import { render, staticRenderFns } from "./CheckinFaceList.vue?vue&type=template&id=1533d200"
import script from "./CheckinFaceList.vue?vue&type=script&lang=js"
export * from "./CheckinFaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports